import React, { useState } from 'react';
import video from 'assets/videos/digital.mp4';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  HeroButtonWrapper,
  ArrowForward,
  ArrowRight
} from './hero.styles';
import { Button as HeroButton } from 'components/common/Button';

const HeroSection = () => {
  const [hover, setHover] = useState(false);

  const onHover = () => setHover(!hover);

  return (
    <HeroContainer id="/">
      <HeroBg>
        <VideoBg autoPlay loop muted src={video} type="video/mp4" />
        <HeroContent>
          <HeroTitle>
            Welcome next level crypto wallet with easy, fast and secure
            transfer.
          </HeroTitle>
          <HeroSubtitle>
            Sign up for a new accounts today and receive 25% discount on every
            first project.
          </HeroSubtitle>
          <HeroButtonWrapper>
            <HeroButton
              to="signup"
              smooth={true}
              spy={true}
              exact="true"
              onMouseEnter={onHover}
              onMouseLeave={onHover}
              primary
              dark
            >
              Learn More {hover ? <ArrowForward /> : <ArrowRight />}
            </HeroButton>
          </HeroButtonWrapper>
        </HeroContent>
      </HeroBg>
    </HeroContainer>
  );
};

export default HeroSection;
